import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SupplierContactService = {
  async getBySupplierCode(code) {
    const requestScreenData = {
      url: "api/SupplierContact",
      top: "1",
      filter: `SupplierCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/SupplierContact",
      expand: "Supplier($select=Code,Name,SupplierTypeCode)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBySupplierCodeLineNo(customerCode, lineNo) {
    const requestScreenData = {
      url: "api/SupplierContact",
      expand: "Supplier($select=Code,Name)",
      top: "1",
      filter: `SupplierCode eq '${customerCode}' and LineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    params.key = ["LineNo"];
    params.keyType = {
      LineNo: "Int32",
    };

    // params.key = ["RecordId"];
    // params.keyType = {
    //   RecordId: "Guid",
    // };

    return ApiService.createDataSource(url, params);
  },
  dataSourceConfigList(url, params) {
    params.key = ["RecordIdAsString"];
    params.keyType = {
      RecordIdAsString: "String",
    };

    return ApiService.createDataSource(url, params);
  },
  async save(mode, supplierContact) {
    var payload = supplierContact;
    var url = "api/Save_SupplierContact";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.put(
        url,
        supplierContact.RecordId,
        payload,
        "Guid"
      );
    }
  },
  async delete(supplierContact) {
    var url = "api/SupplierContact";

    return await ApiService.delete(url, supplierContact.RecordId, "Guid");
  },
};

const SupplierContactTransactionDistributionService = {
  async getBySupplierCodeLineNo(code, lineNo) {
    const requestScreenData = {
      url: "api/SupplierContactTransactionDistribution",
      filter: `SupplierCode eq '${code}' and LineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export {
  SupplierContactService,
  SupplierContactTransactionDistributionService,
};
